import React from "react";
import { CalendarDays } from "lucide-react";
import { BasicSelect, CardShell, FieldLabel } from "./card-handler";


interface MarkAsSentCardProps {
  config: Record<string, any>;
  onUpdate: (config: Record<string, any>) => void;
  onDelete: () => void;
  onReset: () => void;
  bare?: boolean;
}

export const MarkAsSentCard: React.FC<MarkAsSentCardProps> = ({
  config,
  onUpdate,
  onDelete,
  onReset,
  bare,
}) => {
  const update = (patch: Record<string, any>) => onUpdate({ ...config, ...patch });

  return (
    <CardShell
      title="Mark as Sent"
      description="Updates contact status to avoid duplicate messages"
      onDelete={onDelete}
      onReset={onReset}
      bare={bare}
    >
        <div className="mb-3">
          <FieldLabel>Data Source</FieldLabel>
          <BasicSelect
            value={config.dataSource ?? "csv"}
            onChange={(value) => update({ dataSource: value })}
            options={[{ label: "CSV", value: "csv" }]}
          />
        </div>

        <div className="mb-3">
          <FieldLabel>Update Column</FieldLabel>
          <BasicSelect
            value={config.updateColumn ?? "Last_wished_on"}
            onChange={(value) => update({ updateColumn: value })}
            options={[{ label: "Last Wished On", value: "Last_wished_on" }]}
          />
        </div>

        <FieldLabel>Update Value</FieldLabel>
        <div className="relative">
          <input
            value={config.updateValue ?? "Today"}
            onChange={(e) => update({ updateValue: e.target.value })}
            className="w-full border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-sm outline-none focus:ring-1 focus:ring-indigo-300 pr-9"
          />
          <CalendarDays size={17} className="absolute right-3 top-2.5 text-gray-500 dark:text-gray-400 pointer-events-none" />
        </div>
    </CardShell>
  );
};